module.exports = __webpack_public_path__ + "images/application/i-scheduled-c6414dcc.svg";